import { FC } from "react";
import { Box } from "@mui/material";

interface Props {
  src: string;
  alt: string;
}

export const Image: FC<Props> = ({ src, alt }): JSX.Element => {
  return (
    <Box
      sx={{
        aspectRatio: "1",
        backgroundImage: `url("${src}")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100%"
      }}
      aria-label={alt}
      data-testid="carousel-image"
    ></Box>
  );
};
